import React from 'react';
import { useIntl } from 'react-intl';
import { defineMessages } from 'react-intl.macro';
import { useFragment } from 'react-relay/hooks';

import { graphql } from 'babel-plugin-relay/macro';
import { get } from 'lodash';

import { Typography, TypographyProps } from 'embeds/components';

import { TypographyReminderType_EmbedReminder$key } from './__generated__/TypographyReminderType_EmbedReminder.graphql';

const messages = defineMessages({
  appointment: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.appointment',
    defaultMessage: 'Appointment',
  },
  feedback: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.feedback',
    defaultMessage: 'Feedback',
  },
  referral: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.referral',
    defaultMessage: 'Referral',
  },
  outboundReferral: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.outboundReferral',
    defaultMessage: 'Outbound Referral',
  },
  followup: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.followup',
    defaultMessage: 'Follow-up',
  },
  patientForm: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.patientForm',
    defaultMessage: 'Patient Form',
  },
  recall: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.recall',
    defaultMessage: 'Recall',
  },
  telehealth: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.telehealth',
    defaultMessage: 'Telehealth',
  },
  waitingRoom: {
    id: 'embeds.deprecated.fragments.TypographyReminderType.waitingRoom',
    defaultMessage: 'Waiting Room',
  },
});

export interface TypographyReminderTypeProps extends Omit<TypographyProps, 'classes'> {
  fragmentRef: TypographyReminderType_EmbedReminder$key;
}

const TypographyReminderType: React.FC<TypographyReminderTypeProps> = ({ fragmentRef, ...rest }) => {
  const reminder = useFragment<TypographyReminderType_EmbedReminder$key>(
    graphql`
      fragment TypographyReminderType_EmbedReminder on Reminder {
        type
      }
    `,
    fragmentRef,
  );

  const { formatMessage } = useIntl();

  const message = get(messages, reminder.type || '');
  if (!message) {
    return null;
  }
  return <Typography {...rest}>{formatMessage(message)}</Typography>;
};

export default TypographyReminderType;
